module.exports = __webpack_public_path__ + "img/button _QR_TC_pink.10f8cb12.png";